import {
  Box,
  Button,
  IconButton,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  styled,
  Dialog,
  Tooltip,
} from "@mui/material";
import { CopyToClipboard } from "react-copy-to-clipboard";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./TCMStatusSearch.module.css";
import { useEffect, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Container, Row, Col, Form } from "react-bootstrap";
import { ColDef } from "ag-grid-enterprise";
import { TCMStatusApi } from "../../api/tcmStatusSearchApi/tcmStatusSearchApi";
import PushPinIcon from "@mui/icons-material/PushPin";
import ExcelIcon from "../../assets/images/ExcelExport.png";
import { UserGridPreferenceModel } from "../../types/UserGridPreferenceModel";
import {
  getUserGridPreference,
  saveUserGridPreference,
} from "../../api/userDataApi/userGridPreferenceAPI";
import { multipleDownloadFile } from "../../api/simpleSearchApi/simpleSearchApi";
import Loading from "../Alert/Loading";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import VisibilityIcon from "@mui/icons-material/Visibility";
import InfoIcon from "@mui/icons-material/Info";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import HistoryIcon from "@mui/icons-material/History";
import SearchIcon from "@mui/icons-material/Search";
import AssetHistory from "../Alert/AssetHistory";
import InfoDrawer from "../SimpleSearch/InfoDrawer";
import { urlConfig } from "../../config/urlConfig";
import { useSnackbar } from "../Common/SnackbarContext";
import { FormatDate, FormatDateWithoutTime } from "../Common/CommonMethods";
import moment from "moment";
import LocalStorageUtil from "../../utils/localStorage";
import { downloadFile } from "../../api/downstreamSummaryApi/downstreamSummaryApi";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

interface ChildComponentProps {
  email: string;
  businessUnitData: any;
}
const TCMStatusSearch: React.FC<ChildComponentProps> = ({
  email,
  businessUnitData,
}) => {
  const pageSizeSelector = [50, 100, 250, 500];
  const defaulPageSize = 50;

  const gridRef = useRef<AgGridReact>(null);
  const [open, setOpen] = useState(false);
  const [jsonPayloadValue] = useState("");
  const [copyValue, setCopyValue] = useState(false);
  const [rowData, setRowData] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState("");
  const [cusipValue, setcusipValue] = useState("");
  const [gridRecordExist, setGridRecordExist] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [assetHistoryOpen, setAssetHistoryOpen] = useState(false);
  const [assetHistoryData, setAssetHistoryData] = useState<any>(null);
  const [selectedDocument, setSelectedDocument] = useState<any>(null);
  const [_dialogOpen, set_DialogOpen] = useState(false); // NOSONAR
  const [drawerOpen, setDrawerOpen] = useState(false);
  const toggleDrawer = (open: boolean) => () => {
    setDrawerOpen(open);
  };
  const { showSnackbar } = useSnackbar();
  const [validationDocumentId, setValidationDocumentId] = useState<
    string | null
  >("");

  const handleClose = () => {
    setCopyValue(false);
    setOpen(false);
  };

  const handleCopyToClipboard = () => {
    setCopyValue(true);
  };

  //Action cell renderer
  const ActionCellRenderer = (params: any) => {
    const rowData = params.data;
    if (params.data === undefined) {
      return "";
    } else {
      return (
        <div>
          <Tooltip title="Click here to download the documents">
            <IconButton
              className="icon-button"
              style={{ padding: "2px" }}
              onClick={() => downloadSelectedFiles(rowData)}
            >
              <FileDownloadIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Click to view">
            <IconButton
              className="icon-button"
              style={{ padding: "2px" }}
              onClick={() => viewDocument(rowData)}
            >
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Click to view the file information and history">
            <IconButton
              className="icon-button"
              style={{ padding: "2px" }}
              onClick={() => infoDocument(rowData)}
            >
              <InfoIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Click to view Asset History">
            <IconButton
              className="icon-button"
              style={{ padding: "2px" }}
              onClick={() => viewHistory(rowData)}
            >
              <HistoryIcon />
            </IconButton>
          </Tooltip>
        </div>
      );
    }
  };

  //Defined grid column
  const [columnDef] = useState<ColDef[]>([
    {
      headerName: "#",
      width: 50,
      sortable: false,
      filter: false,
      resizable: false,
      colId: "col1",
      valueGetter: (params) => {
        return params.node ? (params.node.rowIndex ?? 0) + 1 : 0;
      },
      cellStyle: () => {
        return { borderright: "1px solid #dee2e6" };
      },
    },
    {
      headerName: "Document ID",
      field: "documentID",
      width: 180,
      hide: false,
      colId: "col2",
      sortable: true,
      filter: true,
      resizable: true,
      enableRowGroup: true,
    },
    {
      headerName: "CUSIP",
      field: "cusip",
      width: 180,
      hide: false,
      colId: "col3",
      sortable: true,
      filter: true,
      resizable: true,
      enableRowGroup: true,
    },
    {
      headerName: "Document Date",
      field: "documentDate",
      width: 180,
      hide: false,
      colId: "col4",
      autoHeight: true,
      cellClass: "dateFormat",
      enableRowGroup: true,
      sortable: true,
      filter: true,
      resizable: true,
      valueFormatter: (params: any) => FormatDateWithoutTime(params.value),
    },
    {
      headerName: "Document Type",
      field: "docTypeCode",
      width: 180,
      hide: false,
      colId: "col5",
      sortable: true,
      filter: true,
      resizable: true,
      enableRowGroup: true,
    },
    {
      headerName: "Source",
      field: "fileName",
      width: 220,
      hide: false,
      colId: "col6",
      sortable: true,
      filter: true,
      resizable: true,
      enableRowGroup: true,
    },
    {
      headerName: "IngestionTime",
      field: "sourceIngestionTime",
      width: 220,
      hide: false,
      colId: "col7",
      autoHeight: true,
      cellClass: "dateFormat",
      enableRowGroup: true,
      sortable: true,
      filter: true,
      resizable: true,
      valueFormatter: (params) => {
        return params.value ? FormatDate(params.value) : "";
      },
    },
    {
      headerName: "APF Send Time",
      field: "apfExportTime",
      width: 270,
      hide: false,
      colId: "col8",
      autoHeight: true,
      cellClass: "dateFormat",
      sortable: true,
      filter: true,
      resizable: true,
      enableRowGroup: true,
      valueFormatter: (params) => {
        return params.value ? FormatDate(params.value) : "";
      },
    },
    {
      headerName: "APF Receive Time",
      field: "apfReceiveTime",
      width: 290,
      hide: false,
      colId: "col9",
      cellClass: "dateFormat",
      sortable: true,
      filter: true,
      resizable: true,
      enableRowGroup: true,
      valueFormatter: (params) => {
        return params.value ? FormatDate(params.value) : "";
      },
    },
    {
      headerName: "OPF Send Time",
      field: "opfExportTime",
      width: 150,
      hide: false,
      colId: "col10",
      cellClass: "dateFormat",
      sortable: true,
      filter: true,
      resizable: true,
      enableRowGroup: true,
      valueFormatter: (params) => {
        return params.value ? FormatDate(params.value) : "";
      },
    },
    {
      headerName: "OPF Receive Time",
      field: "opfReceiveTime",
      width: 300,
      hide: false,
      colId: "col11",
      cellClass: "dateFormat",
      sortable: true,
      filter: true,
      resizable: true,
      enableRowGroup: true,
      valueFormatter: (params) => {
        return params.value ? FormatDate(params.value) : "";
      },
    },
    {
      headerName: "VIS Send Time",
      field: "visExportTime",
      width: 150,
      hide: false,
      colId: "col12",
      cellClass: "dateFormat",
      sortable: true,
      filter: true,
      resizable: true,
      enableRowGroup: true,
      valueFormatter: (params) => {
        return params.value ? FormatDate(params.value) : "";
      },
    },
    {
      headerName: "VIS Receive Time",
      field: "visReceiveTime",
      hide: false,
      colId: "col13",
      cellClass: "dateFormat",
      sortable: true,
      filter: true,
      resizable: true,
      enableRowGroup: true,
      valueFormatter: (params) => {
        return params.value ? FormatDate(params.value) : "";
      },
    },
    {
      headerName: "QC DocId",
      field: "qcDocID",
      hide: false,
      colId: "col14",
      sortable: true,
      filter: true,
      resizable: true,
      enableRowGroup: true,
    },
    {
      headerName: "Association ID",
      field: "associationID",
      hide: false,
      colId: "col15",
      sortable: true,
      filter: true,
      resizable: true,
      enableRowGroup: true,
    },
    {
      headerName: "Supplement Date",
      field: "supplementDate",
      hide: false,
      colId: "col16",
      cellClass: "dateFormat",
      sortable: true,
      filter: true,
      resizable: true,
      enableRowGroup: true,
      valueFormatter: (params) => {
        return params.value ? FormatDateWithoutTime(params.value) : "";
      },
    },
    {
      headerName: "Revised Date",
      field: "revisedDate",
      hide: false,
      colId: "col17",
      cellClass: "dateFormat",
      sortable: true,
      filter: true,
      resizable: true,
      enableRowGroup: true,
      valueFormatter: (params) => {
        return params.value ? FormatDateWithoutTime(params.value) : "";
      },
    },
    {
      headerName: "Amendment Date",
      field: "amendmentDate",
      hide: false,
      colId: "col18",
      cellClass: "dateFormat",
      sortable: true,
      filter: true,
      resizable: true,
      enableRowGroup: true,
      valueFormatter: (params) => {
        return params.value ? FormatDateWithoutTime(params.value) : "";
      },
    },
    {
      field: "Actions",
      headerName: "Actions",
      sortable: false,
      enableRowGroup: false,
      pinned: "right",
      lockPinned: true,
      suppressSizeToFit: true,
      width: 140,
      cellClass: "actions-button-cell",
      cellRenderer: ActionCellRenderer,
      filter: false,
      resizable: false,
      colId: "colAction",
    },
  ]);

  //File Download - Action buttons events
  const fileDownload = async (params: any) => {
    const objDownloadFile = {
      documentStreamID: params.documentStreamID,
      contextName: LocalStorageUtil.getItem("contextName")?.toString(),
    };
    try {
      setLoading(true);
      const response = await downloadFile(objDownloadFile);
      if (response.status === 200) {
        setLoading(false);
        const data = response.data;
        const contentType = response.headers["content-type"];
        const linkElement = document.createElement("a");
        const blob = new Blob([data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        linkElement.href = url;
        linkElement.setAttribute("download", params.fileName);
        const clickEvent = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false,
        });
        linkElement.dispatchEvent(clickEvent);
      }
      if (response) {
        showSnackbar("Documents downloaded successfully");
      } else {
        showSnackbar("Unable to download file !", true);
      }
    } catch (error) {
      showSnackbar("Something went wrong !!!", true);
    } finally {
      set_DialogOpen(false);
      setLoading(false);
    }
  };

  const downloadSelectedFiles = async (params: any) => {
    if (!gridRef.current) return;
    const selectedRows = gridRef.current.api.getSelectedRows();

    if (selectedRows.length === 0) {
      showSnackbar("Please select at least one file to download.", true);
      return;
    }

    // If only one file is selected, use the existing single file download
    if (selectedRows.length === 1) {
      fileDownload(selectedRows[0]);
      return;
    }

    try {
      let multiFileDownload = null;
      if (selectedRows.length > 1) {
        let documentStreamID: number[] = [];

        selectedRows.forEach((item: any) => {
          documentStreamID.push(item.DocumentStreamID);
        });

        if (documentStreamID.length > 1) {
          multiFileDownload = {
            SearchText: documentStreamID.toString(),
            contextName:
              businessUnitData?.contextName ||
              LocalStorageUtil.getItem("contextName")?.toString(),
          };
        }
      }
      setLoading(true);
      showSnackbar("Download Started");
      // Call your API to get the zip file (implement GetDownloadFiles in your backend)
      const response = await multipleDownloadFile(multiFileDownload);
      if (response.status === 200) {
        const data = response.data;
        const contentType =
          response.headers["content-type"] || "application/zip";
        const fileName = "documents.zip";
        const linkElement = document.createElement("a");
        const blob = new Blob([data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        linkElement.href = url;
        linkElement.setAttribute("download", fileName);
        const clickEvent = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false,
        });
        linkElement.dispatchEvent(clickEvent);
        showSnackbar("Documents downloaded successfully");
      } else {
        showSnackbar("Unable to download file!", true);
      }
    } catch (error) {
      showSnackbar("Something went wrong !!!", true);
    } finally {
      set_DialogOpen(false);
      setLoading(false);
    }
  };

  //Info Document - Action buttons events
  const infoDocument = (rowData: any) => {
    const modifiedData = {
      ...rowData,
      DocumentStreamID: rowData.documentStreamID,
    };
    setSelectedDocument(modifiedData);
    toggleDrawer(true)();
  };

  //View Document - Action buttons events
  const viewDocument = (rowData: any) => {
    const id = rowData.documentStreamID;
    const encodedId = btoa(id);
    const fileName = rowData.fileName.replace(/\.[^/.]+$/, "");
    const url = !urlConfig.isDeployed
      ? `/documentviewer/${encodedId}?FileName=${fileName}`
      : `/docdistrov2/documentviewer/${encodedId}?FileName=${fileName}`;
    popupCenter(url, "Document Viewer", 1100, 550);
  };

  //History - Action buttons events
  const viewHistory = (rowData: any) => {
    const modifiedData = {
      ...rowData,
      DocumentStreamID: rowData.documentStreamID,
    };
    setAssetHistoryData(modifiedData); // Pass the modified data
    setAssetHistoryOpen(true);
  };

  // Close AssetHistory
  const closeAssetHistory = () => {
    setAssetHistoryOpen(false);
    setAssetHistoryData(null);
  };

  const popupCenter = (url: string, title: string, w: number, h: number) => {
    const dualScreenLeft = window.screenLeft ?? window.screenX ?? 0;
    const dualScreenTop = window.screenTop ?? window.screenY ?? 0;

    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      window.screen.width;

    const height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      window.screen.height;

    const left = width / 3 - w / 3 + dualScreenLeft;
    const top = height / 3 - h / 3 + dualScreenTop;
    const newWindow = window.open(
      url,
      title,
      `readonly=true, scrollbars=yes, width=${w}, height=${h}, top=${top}, left=${left}`,
    );
    if (newWindow) {
      newWindow.focus();
    }
  };

  //#endregion
  const handleInputChange = (event: any) => {
    setSearchValue(event.target.value);
  };
  const handleCUSIPInputChange = (event: any) => {
    setcusipValue(event.target.value);
  };

  // Helper function to handle error responses
  const handleErrorResponse = (
    status: number,
    setGridRecordExist: (exists: boolean) => void,
    setRowData: (data: any[]) => void,
    showSnackbar: (message: string, isError: boolean) => void,
  ): boolean => {
    const errorMessages: Record<number, string> = {
      404: "TCMStatus not found",
      500: "Internal Server Error",
      401: "Invalid Request UserName/Password",
    };

    const errorMessage = errorMessages[status];

    if (errorMessage) {
      setGridRecordExist(false);
      setRowData([]);
      showSnackbar(errorMessage, true);
      return true;
    }

    return false;
  };

  // Helper function to validate search input
  const validateSearchInput = (
    searchValue: string,
    setValidationDocumentId: (message: string) => void,
  ): boolean => {
    if (!searchValue || searchValue === "") {
      setValidationDocumentId("Please enter the DocumentId");
      return false;
    }
    return true;
  };

  // Helper function to handle successful data response
  const handleSuccessResponse = async (
    tcmStatusModelInfo: any[],
    setRowData: (data: any[]) => void,
    setGridRecordExist: (exists: boolean) => void,
    getUserGridPreferences: () => Promise<any>,
    applyGridPreferences: (preferences: any) => void,
    gridRef: React.RefObject<AgGridReact>,
  ): Promise<void> => {
    setRowData(tcmStatusModelInfo);

    if (tcmStatusModelInfo.length === 0) {
      setGridRecordExist(false);
      return;
    }

    setGridRecordExist(true);

    const gridPreferences = await getUserGridPreferences();
    if (gridPreferences) {
      applyGridPreferences(gridPreferences);
    }

    const columnState = gridRef.current?.api.getColumnState();
    if (columnState) {
      await getUserGridPreferences();
    }
  };

  // Refactored getData function
  const getData = async () => {
    // Validate input
    if (!validateSearchInput(searchValue, setValidationDocumentId)) {
      setSearchValue("");
      return;
    }

    try {
      setValidationDocumentId(null);
      setLoading(true);

      // Fetch data
      const tcmStatusModelInfo = await TCMStatusApi.getTCMStatusSearchData(
        searchValue,
        cusipValue,
      );

      // Handle error responses
      const isError = handleErrorResponse(
        tcmStatusModelInfo.status,
        setGridRecordExist,
        setRowData,
        showSnackbar,
      );

      if (isError) {
        return;
      }

      // Handle successful response
      await handleSuccessResponse(
        tcmStatusModelInfo,
        setRowData,
        setGridRecordExist,
        getUserGridPreferences,
        applyGridPreferences,
        gridRef,
      );
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setLoading(false);
    }
  };

  const handleExport = () => {
    if (gridRef.current) {
      gridRef.current.api.exportDataAsExcel({
        fileName: "TCMStatusSearch_" + moment().format("YYYYMMDD") + ".xlsx",
        sheetName: "TCMStatusSearch Report",
        columnKeys: columnDef
          .map((colDef) => colDef.colId)
          .filter(
            (colId): colId is string =>
              colId !== "colAction" && colId !== undefined,
          ),
        processCellCallback: function (params) {
          return params.value;
        },
      });
    }
  };

  // Reapply grid state on component update
  useEffect(() => {
    const reapplyGridState = async () => {
      const gridPreferences = await getUserGridPreferences();
      if (gridPreferences) {
        applyGridPreferences(gridPreferences);
      }
    };
    reapplyGridState();
  }, [rowData]);

  //Save grid preferences
  const handleSaveGridPreferences = async () => {
    setLoading(true);
    if (gridRef.current) {
      const gridState = gridRef.current.api.getColumnState();
      const userGridPreference: UserGridPreferenceModel = {
        Area: "TCMStatusSearch",
        UserID: 2239,
        BusinessUnitID: 1259,
        ContextName: "DocDistro_TCMOne",
        GridBlob: JSON.stringify(gridState),
        LastModifiedBy: "DocDistro-UserGridPreferencesAPI",
        LastModifiedDate: new Date().toISOString(),
      };

      try {
        const tcmStatusModelInfo =
          await saveUserGridPreference(userGridPreference);
        if (tcmStatusModelInfo) {
          console.log("Grid state successfully saved.");
        }
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const getUserGridPreferences = async () => {
    const userGridPreference = {
      Area: "TCMStatusSearch",
      UserID: 2239,
      BusinessUnitID: 1259,
      ContextName: "DocDistro_TCMOne",
    };

    try {
      const tcmStatusModelInfo =
        await getUserGridPreference(userGridPreference);
      if (tcmStatusModelInfo) {
        console.log("Grid state successfully fetched.");
      }
      return tcmStatusModelInfo;
    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setLoading(false);
    }
  };

  //Apply grid preferences
  const applyGridPreferences = (gridPreferences: any) => {
    if (gridPreferences) {
      try {
        const gridState = JSON.parse(gridPreferences);
        if (gridRef.current) {
          gridRef.current.api.applyColumnState({
            state: gridState,
            applyOrder: true,
          });
          gridRef.current.api.applyColumnState(gridState);
          gridRef.current.api.setFilterModel(gridState);
        }
      } catch (error) {
        console.error("Error parsing grid preferences:", error);
      }
    } else {
      console.warn("No grid preferences found or GridBlob is undefined.");
    }
  };

  return (
    <Container fluid>
      <NavigationBar
        menuTitle="Queue Managment"
        screenTitle=""
        title="TCMStatus Search"
        text="TCMStatus Search"
      />
      <Row
        className="mb-2"
        style={{
          color: "var(--aggrid-text-color)",
          fontSize: "12px",
          marginTop: "20px",
          marginLeft: ".1em",
        }}
      >
        <Col md={2} style={{ width: "31%" }}>
          <Form.Group controlId="formName">
            <Form.Label className="input-labels">
              Document ID
              <span
                className="required"
                style={{ color: "var(--aggrid-text-color)", fontSize: "11px" }}
              >
                *
              </span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter Document ID"
              value={searchValue}
              onChange={handleInputChange}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  // Check if the Enter key is pressed
                  getData(); // Trigger the search action
                }
              }}
              style={{ width: "100%", height: "30px", fontSize: "11px" }}
              required
            />
            {validationDocumentId && (
              <Form.Text style={{ color: "red" }}>
                {validationDocumentId}
              </Form.Text>
            )}
            <Form.Text style={{ color: "red" }}></Form.Text>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group controlId="formPhoneNumber">
            <Form.Label className="input-labels" style={{ fontSize: "11px" }}>
              CUSIP
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter CUSIP"
              value={cusipValue}
              onChange={handleCUSIPInputChange}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  // Check if the Enter key is pressed
                  getData(); // Trigger the search action
                }
              }}
              style={{ width: "100%", height: "30px", fontSize: "11px" }}
            />
          </Form.Group>
        </Col>
        <Col md={2}>
          <Tooltip title="Please click to Search">
            <SearchIcon
              onClick={getData}
              style={{
                fontSize: "11px",
                height: "25px",
                width: "25px",
                marginTop: "2.5em",
              }}
            />
          </Tooltip>
        </Col>
        <Col
          md={4}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            marginTop: "2em",
          }}
        >
          {gridRecordExist && (
            <>
              <Tooltip title="Click to save grid state">
                <IconButton
                  onClick={handleSaveGridPreferences}
                  className="preference-icon"
                >
                  <PushPinIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="Click to export the grid content in excel">
                <button
                  type="button"
                  onClick={handleExport}
                  style={{
                    background: "none",
                    border: "none",
                    padding: 0,
                    cursor: "pointer",
                  }}
                  aria-label="Export to Excel"
                >
                  <img
                    src={ExcelIcon}
                    alt="Doc-Distro"
                    className="excel-icon"
                  />
                </button>
              </Tooltip>
            </>
          )}
        </Col>
      </Row>
      <Row>
        <Loading show={loading} />
        <Col xs={12} md={8} lg={6} className={styles.marginLeftResponsive}>
          <Box>
            <div style={{ width: "185%" }}>
              <Box
                component="form"
                sx={{ "& .MuiTextField-root": { m: 1, width: "50ch" } }}
                noValidate
                autoComplete="off"
              ></Box>
            </div>
            {/* <div className="queue-table-view clearfix"> */}

            <div
              className="ag-theme-quartz-dark"
              style={{
                height: "67.5vh",
                width: "200%",
                marginTop: ".1vh",
              }}
            >
              <AgGridReact
                columnDefs={columnDef}
                rowData={rowData}
                ref={gridRef}
                pagination={true}
                paginationPageSize={defaulPageSize}
                paginationPageSizeSelector={pageSizeSelector}
                gridOptions={{
                  rowSelection: {
                    mode: "multiRow",
                    checkboxes: true,
                    headerCheckbox: true,
                    enableClickSelection: false,
                  },
                }}
                headerHeight={30}
                rowGroupPanelShow="always"
                pivotPanelShow="always"
                overlayNoRowsTemplate={
                  '<span class="ag-overlay-loading-center">No rows to show</span>'
                }
                loading={!rowData}
              />
            </div>
            <div>
              <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                PaperProps={{ sx: { width: 400, height: 550 } }}
              >
                <DialogTitle
                  className={styles.dialogtitle}
                  sx={{
                    m: 0,
                    p: 1,
                    fontWeight: "bold",
                    fontSize: "14px",
                    lineHeight: "1.5",
                    padding: "8px",
                  }}
                  id="customized-dialog-title"
                >
                  Json Payload
                </DialogTitle>
                <IconButton
                  aria-label="close"
                  onClick={handleClose}
                  sx={(theme) => ({
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                    padding: "0px",
                  })}
                  style={{ color: "white" }}
                >
                  <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                  <TextField
                    multiline
                    aria-label="minimum height"
                    maxRows={26}
                    style={{ width: "100%", overflow: "auto" }}
                    value={jsonPayloadValue}
                    aria-readonly
                    InputProps={{
                      style: {
                        backgroundColor: "#f9f9f9",
                        border: "1px solid #ccc",
                        font: "menu",
                        fontFamily: "monospace",
                      },
                    }}
                  ></TextField>
                  {copyValue ? (
                    <span style={{ color: "green", fontSize: "14px" }}>
                      {" "}
                      Copied text to clipboard.
                    </span>
                  ) : null}
                </DialogContent>
                <DialogActions>
                  <CopyToClipboard
                    text={jsonPayloadValue}
                    onCopy={handleCopyToClipboard}
                  >
                    <Button
                      className={styles.copytoclipboard}
                      style={{
                        textTransform: "none",
                        borderRadius: "0px",
                        background: "rgb(77, 123, 167) !important",
                        color: "#ddd !important",
                        fontSize: "11px",
                        padding: "5px 12px",
                        border: "1px solid #144979",
                        margin: "0 5px 5px 5px",
                        whiteSpace: "white-space",
                      }}
                    >
                      Copy to clipboard
                    </Button>
                  </CopyToClipboard>
                </DialogActions>
              </BootstrapDialog>
            </div>
            <div>
              <InfoDrawer
                isOpen={drawerOpen}
                onClose={toggleDrawer(false)}
                title="Document Info"
                tabLabels={["Information", "Version History"]}
                selectedDocument={selectedDocument}
                screenType="TCMStatusSearch"
              />
            </div>
            {/* Assest History popup */}
            {assetHistoryOpen && (
              <AssetHistory
                isOpen={assetHistoryOpen}
                onClose={closeAssetHistory}
                title=""
                selectedData={assetHistoryData}
              />
            )}
          </Box>
        </Col>
      </Row>
    </Container>
  );
};

export default TCMStatusSearch;
